/**
 * The reading every scan gets with no model (idea 25): `RULES_SPEC` over the
 * OCR text, as a normalised extraction. Store, date, total, organisation
 * number and VAT; never items or categories. It is recorded under
 * `RULES_PROVIDER`.
 */

import { normalizeExtraction, type NormalizedExtraction } from '../extraction.js';
import { readingFrom } from './resolve.js';
import { runReading, stepRegistry } from './runner.js';
import { RULES_SPEC } from './specs.js';
import { BUILTIN_STEPS } from './steps/index.js';

const REGISTRY = stepRegistry(...BUILTIN_STEPS);

/** The rules reading of `text`, with dates judged against `today`. */
export async function readWithRules(text: string, today: Date): Promise<NormalizedExtraction> {
  const state = await runReading(RULES_SPEC, REGISTRY, { text, today, categories: [] }, {});
  return normalizeExtraction(readingFrom(state.resolved));
}
